<script>
import referralCourses from '../../common/referral-courses.js';

export default {
	name: 'ReferralBanner',
	template: `<slot v-bind="self" />`,

	props: {
		current_company: ''
	},

	computed: {
		self: function() {
			return this;
		},
	},

	data() {
		return {
			courses: referralCourses,
			isShow: true
		}
	},

	created() {
		this.courses.forEach((course) => {
			if (course === this.current_company) {
				this.isShow = false;
			}
		});
	},
}
</script>
